<script lang="ts" setup>
import ProgressBar from '@/components/base/ProgressBar.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import UnstyledButton from '@/components/base/UnstyledButton.vue';
import { ApprovedReviews, RatingTier } from '@/lib/reviews';

defineProps<{ reviews: ApprovedReviews; selectedRating?: RatingTier }>();

const displayRatingStars: RatingTier[] = [5, 4, 3, 2, 1];

const emit = defineEmits(['selectRating']);
</script>

<template>
  <div v-if="reviews.starRatingsCount" class="rating-summary whitespace-nowrap w-fit">
    <UnstyledButton
      v-for="rating in displayRatingStars"
      :key="rating"
      class="flex cursor-pointer"
      @click="emit('selectRating', rating)"
      data-promo="1"
      data-promo-name="Reviews"
      :data-promo-creative="`Review Distribution: ${rating} star`"
      :data-test="`rating-${rating}`"
    >
      <BaseBodyText
        class="w-11 text-nuts-cyan-800"
        :class="rating === selectedRating ? 'underline md:no-underline' : 'md:text-current'"
      >
        {{ rating }} star
      </BaseBodyText>
      <div
        class="progress-bar"
        :class="rating === selectedRating ? 'bg-neutral-400 border border-solid' : 'bg-neutral-300'"
      >
        <ProgressBar :percentage="reviews.starRatingsCount[rating].percentage" />
      </div>
      <BaseBodyText class="self-center text-right w-11">
        {{ reviews.starRatingsCount[rating].percentage.toFixed(1) }}%
      </BaseBodyText>
    </UnstyledButton>
  </div>
</template>

<style lang="scss">
.rating-summary {
  .progress-bar {
    display: block;
    width: 260px;
    height: 16px;
    margin: auto 4px;
    border-radius: 11px;
    overflow: hidden;
    > div {
      height: 100%;
      background-color: $sunglow;
      border-radius: 11px 0 0 11px;
      min-width: 1%;
    }
  }
}
</style>
